// extracted by mini-css-extract-plugin
export var center = "_4v-2";
export var clickableRow = "_4v-5";
export var expandedRow = "_4v-7";
export var hoverable = "_4v-4";
export var left = "_4v-1";
export var right = "_4v-3";
export var row = "_4v-0";
export var selectedRow = "_4v-6";
export var summaryRow = "_4v-8";